// Widget gezinme durumu iframe adresinin hash kisminda tutulur (#tab=help&article=...); sayfa yenilenince ya da adres
// yeni sekmede acilinca ayni ekran gelir. Query'ye yazilmaz: widget query parametrelerini mesajlarla sunucuya gonderiyor
// (App.calculateQueryParams), gezinme bilgisi oraya karismasin. Hash'in bu anahtarlar disindaki kismina dokunulmaz.
const KEYS = ["tab", "chat", "collection", "article"];
const TABS = ["home", "messages", "help"];

const parseHash = (hash) => new URLSearchParams(String(hash || "").replace(/^#/, ""));

/** @returns {{tab: string|null, chat: boolean, collection: string|null, article: string|null}} */
export const readUrlState = (hash = window.location.hash) => {
    const q = parseHash(hash);
    const tab = q.get("tab");
    return {
        tab: TABS.includes(tab) ? tab : null,
        chat: q.get("chat") === "1",
        collection: /^[a-f0-9]{24}$/i.test(q.get("collection") || "") ? q.get("collection") : null,
        article: q.get("article") || null,
    };
};

export const hasUrlState = (s) => !!(s && (s.tab || s.chat || s.collection || s.article));

/**
 * Verilen alanlari adrese yazar (null/false olanlari siler). history.replaceState kullanir; gecmise kayit eklemez.
 * @param {object} patch - tab, chat, collection, article alanlarindan bir kismi
 */
export const writeUrlState = (patch) => {
    try {
        const q = parseHash(window.location.hash);
        KEYS.forEach((k) => {
            if (!(k in patch)) return;
            const v = patch[k];
            if (v === null || v === undefined || v === false || v === "") q.delete(k);
            else q.set(k, v === true ? "1" : String(v));
        });
        const hash = q.toString() ? `#${q.toString()}` : "";
        if (hash === (window.location.hash === "#" ? "" : window.location.hash)) return;
        window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search + hash);
    } catch (e) {
        /* eski tarayici ya da kisitli ortam: durum tutulmaz */
    }
};



// WEBPACK FOOTER //
// ./src/utils/shell/urlState.js